module.exports = __webpack_public_path__ + "static/master.png";